import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

import { IPunchAssignmentsItemDTO } from 'src/api/dtos';
import { IError } from 'src/api/types';

import { fetchPunchAssignments } from './punchAssignment.actions';
import { IPunchAssignmentState } from './punchAssignment.types';

const initialState: IPunchAssignmentState = {
  data: [],
  loading: false,
  error: null,
};

export const punchAssignmentsSlice = createSlice({
  name: 'punchAssignments',
  initialState,
  reducers: {},
  extraReducers: (build) => {
    /* fetchPushAssignments */
    build.addCase(
      fetchPunchAssignments.fulfilled.type,
      (state: Draft<IPunchAssignmentState>, { payload }: PayloadAction<IPunchAssignmentsItemDTO[]>) => {
        return {
          ...state,
          data: payload,
          loading: false,
        };
      },
    );
    build.addCase(fetchPunchAssignments.pending.type, (state: Draft<IPunchAssignmentState>) => {
      return {
        ...state,
        error: null,
        loading: true,
      };
    });
    build.addCase(
      fetchPunchAssignments.rejected.type,
      (state: Draft<IPunchAssignmentState>, { payload }: PayloadAction<IError>) => {
        return {
          ...state,
          error: payload,
          loading: false,
        };
      },
    );
  },
});
